import * as types from './constants';

// Edit Account Email
export const editAccountEmailRequest = data => (
  { type: types.EDIT_ACCOUNT_EMAIL_REQUEST, payload: data }
);

export const editAccountEmailDone = data => (
  { type: types.EDIT_ACCOUNT_EMAIL_DONE, payload: data }
);

export const editAccountEmailFailed = errors => (
  { type: types.EDIT_ACCOUNT_EMAIL_FAILED, payload: errors }
);